'use client';

import { c as _c } from "react/compiler-runtime";
import NotFoundPage from "@/_pages/not-found/not-found-page";
export default function NotFound() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NotFoundPage />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}